module.exports = __webpack_public_path__ + "static/1199905534.c09a50ad.jpg";